
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  
  Flits(document).on('Flits:Navigation:Loaded', function(event){
    var settings = event.detail.settings;
    var obj = {
      title: 'Bienvenue',
      url:'#welcome',
      target:0,
      badge: null,
      icon: null,
      isShow: 1,
      loader:null,
      active:1,
      body_html: '<div id="flits-welcome-div"></div>'
    }
    settings.navs.splice(0, 0, obj);
    
  });

  
  // Loyalty Program 
  function CustomIntregation(){
    var flits_loyalty_program = Flits(".flits-loyalty-program").children().children();
    Flits("#flits_tab_club-milie").find("[data-lion-account]").append(flits_loyalty_program);   
    Flits(".flits-loyalty-program").remove();
    
    var flits_custom_welcome = Flits(".flits-custom-welcome").children();
    Flits("#flits-welcome-div").append(flits_custom_welcome);   
    Flits(".flits_custom_welcome").remove();
  }

  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    CustomIntregation();
    var settings = event.detail.settings;
    settings.active_tab = "#welcome";
     
  });
}(Flits));
